export default function keywordReducer(state = null, action) {
  switch (action.type) {
    case 'SET_CHAT_KEYWORD':
      return action.payload
    default:
      return state
  }
}
